/**
 * SPA 会话存储键与清理（KR15 业主 2026-08-29 反馈：access token 过期后界面卡死、回不到登录页）。
 * 会话只存在本标签页 sessionStorage；这里集中键名与清理，供启动恢复（main.ts）与 401 处理（api/client.ts）共用。
 * 仅影响客户端可见性——服务端始终自行校验签名与有效期，清理本地键不授予任何权限。
 */
export const SESSION_KEYS = ['dstbfs.access_token', 'dstbfs.tenant_id', 'dstbfs.expires_at', 'dstbfs.scope'] as const

export function clearSession(): void {
  try { for (const k of SESSION_KEYS) { sessionStorage.removeItem(k) } } catch { /* private mode / storage disabled: nothing to clear */ }
}
